<p4m-expandable-card-component
  (onExpanded)="onCardExpanded($event)"
  [titleClass]="getTaskStatusClass(task)">
  <ng-container *ngIf="getProgress() > 0" class="card-progress">
    <mat-progress-bar
      mode="determinate"
      [value]="getProgress()"></mat-progress-bar>
  </ng-container>

  <ng-container class="card-title">
    <div style="display: grid; grid-template-columns: auto 1fr">
      <div style="display: flex; flex-direction: row">
        <mat-icon
          class="afo-icon icon-todo-green"
          *ngIf="ppsService.isReady(task)"
        >circle
        </mat-icon>
        <mat-icon
          class="afo-icon icon-todo-red"
          *ngIf="ppsService.isNotReleased(task)"
        >offline_bolt
        </mat-icon>
        <mat-icon
          class="afo-icon icon-todo-yellow"
          *ngIf="ppsService.isPartiallyReleased(task)"
        >circle
        </mat-icon>
        <mat-icon
          class="afo-icon icon-in-progress"
          *ngIf="ppsService.isInProgress(task)"
        >circle
        </mat-icon>
        <mat-icon
          class="afo-icon icon-finished"
          *ngIf="ppsService.isFinished(task)"
        >check_circle
        </mat-icon>
      </div>
      <div class="task-header">
        <div style="font-weight: bold" class="wrap-line">
          <span *ngFor="let field of taskComponentConfig?.headerFields">
            {{ task[field.field] }}
          </span>
        </div>
        <div class="wrap-line">
          {{ task.STARTPLAN | date: 'short' }} -
          {{ task.ENDEPLAN | date: 'short' }}
        </div>
      </div>
      <div style="grid-column: auto / span 2" class="wrap-line">
        <div
          style="
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-items: center;
          ">
          <div class="wrap-line">{{ task.AFOBEZ }}</div>
          <div style="flex: 1 0 auto"></div>
          <div *ngIf="hasActiveTracking(task, user)" class="active-booking-tag">
            {{ 'planning.task.activeTrackingTag' | translate }}
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <div class="card-content">
    <div style="display: grid; grid-template-columns: auto 1fr; grid-gap: 8px">
      <div style="font-weight: bold">
        {{ 'planning.task.infoText' | translate }}
      </div>
      <a (click)="onRedirect(task)" class="wrap-line">{{ task.INFOTEXT }}</a>
      <ng-container *ngFor="let field of taskComponentConfig?.contentFields">
        <ng-container *ngIf="task[field.field] && !hideField(task, field)">
          <div style="font-weight: bold">
            {{ field.labelTranslationKey | translate }}
          </div>
          <ng-container *ngIf="!field.linkIdField; else showAsLink" class="wrap-line">
            <div>
              {{ task[field.field] }}
            </div>
          </ng-container>
          <ng-template #showAsLink>
            <a *ngIf="task[field.field];"
               (click)="redirect(task[field.linkIdField])">
              {{ task[field.field] }}
            </a>
          </ng-template>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="hasActiveTracking(task, user)">
        <div class="active-booking-hint">
          <mat-icon>info</mat-icon>
          <span style="padding: 0.2rem"
          >{{ 'planning.task.activeTrackingHint' | translate }}
            <a class="wrap-line" routerLink="bookings">{{
                'planning.task.activeTracking' | translate
              }}</a></span
          >
        </div>
      </ng-container>

      <ng-container *ngIf="task.PREDECESSORS || task.SUCCESSORS">
        <div style="font-weight: bold">Vorgänger</div>
        <app-chain-info
          #predecessors
          [links]="task.PREDECESSORS"
          direction="Vorgänger"></app-chain-info>
        <div style="font-weight: bold">Nachfolger</div>
        <app-chain-info
          #successors
          [links]="task.SUCCESSORS"
          direction="Nachfolger"></app-chain-info>
      </ng-container>
    </div>
  </div>

  <div class="card-actions">
    <button
      *ngIf="!hasActiveTracking(task, user)"
      mat-button
      color="accent"
      routerLink="/general/info-panels/task/{{ task.OBJECT_ID }}/track">
      {{ 'planning.task.track' | translate }}
    </button>
    <button
      *ngIf="allowStartTracking"
      mat-button
      color="accent"
      (click)="startTracking(task)" routerLink="/general/task/{{task?.OBJECT_ID}}/start-tracking">
      <ng-container
        *ngIf="hasActiveTracking(task, user); else noCurrentTracking">
        {{ 'planning.task.restart' | translate }}
      </ng-container>
      <ng-template #noCurrentTracking>
        {{ 'planning.task.start' | translate }}
      </ng-template>
    </button>
    <button
      *ngIf="allowStartTracking && hasActiveTracking(task, user)"
      mat-button
      color="accent"
      (click)="stopTracking(task)">
      STOP
    </button>
    <button
      *ngIf="
        !ppsService.isInProgress(task) &&
        !ppsService.isFinished(task) &&
        (ppsService.isReady(task) || allowSetUnapprovedTasksInProgress)
      "
      mat-button
      color="accent"
      (click)="ppsService.setTaskInProgress(task.OBJECT_ID)">
      {{ 'planning.task.inProgress' | translate }}
    </button>
    <button
      [matMenuTriggerFor]="menu"
      mat-button
      color="accent"
      aria-label="Aktionen">
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
      <button
        *ngIf="hasActiveTracking(task, user)"
        mat-menu-item
        routerLink="/general/info-panels/task/{{ task.OBJECT_ID }}/track">
        {{ 'planning.task.track' | translate }}
      </button>
      <button
        mat-menu-item
        (click)="ppsService.setTaskComplete(task.OBJECT_ID)">
        <span>{{ 'planning.board.reportFinished' | translate }}</span>
      </button>
      <button mat-menu-item routerLink="/incidents/{{ task.OBJECT_ID }}/create">
        <span>{{ 'planning.board.createIncident' | translate }}</span>
      </button>
      <button
        *ngIf="ppsService.isInProgress(task)"
        mat-menu-item
        (click)="ppsService.interruptTask(task.OBJECT_ID)">
        <span>{{ 'planning.task.interrupt' | translate }}</span>
      </button>
    </mat-menu>
  </div>
</p4m-expandable-card-component>
